import { createSlice } from "@reduxjs/toolkit";
import { fetchInStock } from "./thunk";

interface FetchInStockState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchInStockState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyStateSlice = createSlice({
  name: "InStock",
  initialState,
  reducers: {
    clearInStock: (state) => {
      state.list = [];
      state.rowCount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInStock.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export const { clearInStock } = DailyStateSlice.actions;
export default DailyStateSlice.reducer;
